import {MapAnnouncementType} from "./MapAnnouncementType";

export abstract class MapAnnouncement {

    private readonly map_id: string;
    private readonly type: MapAnnouncementType;
    private readonly value: any;

    protected constructor(map_id: string, type: MapAnnouncementType, value: any) {
        this.map_id = map_id;
        this.type = type;
        this.value = value;
    }

    get MapId() {
        return this.map_id;
    }
    get Type() {
        return this.type;
    }
    serializeValue() {
        return JSON.stringify(this.value);
    }

}
